module.exports = __webpack_public_path__ + "img/news9-2.f2a3078f.png";